<h5 mat-dialog-title appLocalizationPopupDirective localizationCode="SelectIcon">
    {{ 'SelectIcon' | translate: {Default: "Select Icon"} }}
</h5>

<mat-dialog-content>
    <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search icons</mat-label>
        <input matInput type="text" placeholder="Search..." [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"/>
        <mat-icon matPrefix class="icon-item material-icons-outlined">search</mat-icon>
    </mat-form-field>

    <div class="icon-grid">
        <div *ngFor="let category of filteredIconsByCategory | keyvalue" class="icon-category">
            <h3>{{ category.key }}</h3>
            <div class="icons-container">
                <div *ngFor="let icon of category.value" 
                     class="icon-item" 
                     [class.selected]="selectedIcon === icon"
                     appPreventDoubleClick (throttledClick)="selectedIcon = icon">
                    <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate: {Default: "Cancel"} }}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="selectedIcon">{{ 'Select' | translate: {Default: "Select"} }}</button>
</mat-dialog-actions>
